import { useWorkspaceTreatments } from '@/features/splits';

/**
 * Check for automations Split feature flag
 * @returns true if enabled, false otherwise
 */
export const useAutomationsFeatureFlag = () => {
  const { treatments } = useWorkspaceTreatments(['fe_admin_app_automations']);
  const isAutomationsFeatureEnabled =
    treatments.fe_admin_app_automations.treatment === 'on';

  return isAutomationsFeatureEnabled;
};
